import net from "App/net";

var DiagnosticsClient = function () {

};

DiagnosticsClient.prototype.getSpeedLossHistory = function (query) {
  return net.get(`/diagnostics/SpeedLoss`, query);
};


DiagnosticsClient.prototype.getSeaSurfaceTemperature = function (query) {
  return net.get(`/diagnostics/OperationProfile`, query);
};

DiagnosticsClient.prototype.getSpeedLossStatistics = function (vesselId) {
  return net.get(`/diagnostics/Statistics`, {
    vesselId: vesselId
  });
}

DiagnosticsClient.prototype.getLatestSpeedLossStatistics = function (vesselIds) {
  return net.post(`/diagnostics/LatestStatistics`, vesselIds);
}

DiagnosticsClient.prototype.getHullCoatingType = function () {
  return net.get(`/diagnostics/HullCoatingType`);
};

DiagnosticsClient.prototype.getHullCoatingManufacturer = function () {
  return net.get(`/diagnostics/HullCoatingManufacturer`);
};

DiagnosticsClient.prototype.postHullCoatingVessel = function (payload) {
  return net.post(`/diagnostics/HullCoatingVessel`, payload);
};

DiagnosticsClient.prototype.hullCoatingVessel = function (vesselId) {
  return net.get(`/diagnostics/HullCoatingVessel/${vesselId}`);
};

DiagnosticsClient.prototype.hullCoatingVessels = function (vesselIds) {
  return net.post(`/diagnostics/HullCoatingVessels/`, vesselIds);
};

DiagnosticsClient.prototype.diagnosticsChartConfig = function (vesselId) {
  return net.get(`/diagnostics/Config/${vesselId}`);
};

DiagnosticsClient.prototype.diagnosticsChartConfigs = function (vesselIds) {
  return net.post(`/diagnostics/Configs`, vesselIds);
};

DiagnosticsClient.prototype.updateDiagnosticsChartConfig = function (payload) {
  return net.put(`/diagnostics/Config`, payload);
};


DiagnosticsClient.prototype.getPropulsionEfficency = function (query) {
  return net.get(`/diagnostics/PropulsionEfficiencyData`, query);
};

DiagnosticsClient.prototype.getPropulsionEfficencyCurve = function (query) {
  return net.get(`/diagnostics/PropulsionEfficiencyCurve`, query);
};

DiagnosticsClient.prototype.getAddedFuelConsumption = function (vesselId) {
  return net.get(`/diagnostics/AddedFuelConsumption`, {
    vesselId: vesselId
  });
};

DiagnosticsClient.prototype.getEventImpact = function (vesselId, eventDate) {
  return net.get(`/diagnostics/Impact`, {
    vesselId: vesselId,
    eventDate: eventDate
  });
};

DiagnosticsClient.prototype.getAddedFuelConsumptions = function (vesselIds) {
  return net.post(`/diagnostics/AddedFuelConsumptions`, vesselIds);
};

export default new DiagnosticsClient();
